import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ items }) => {
  return (
    <nav 
      className="breadcrumb-nav" 
      style={{ 
        padding: '8px 0', 
        marginBottom: '16px',
        fontSize: '14px'
      }}
    >
      {items.map((item, index) => (
        <span key={index} style={{ display: 'inline-flex', alignItems: 'center' }}>
          {index > 0 && (
            <i 
              className="fa-solid fa-chevron-right" 
              style={{ 
                margin: '0 8px', 
                fontSize: '12px', 
                color: '#6c757d' 
              }}
            ></i>
          )}
          {item.link ? (
            <Link 
              to={item.link} 
              style={{ 
                color: '#29204C', 
                textDecoration: 'none',
                fontWeight: '500'
              }}
              onMouseOver={(e) => e.target.style.textDecoration = 'underline'}
              onMouseOut={(e) => e.target.style.textDecoration = 'none'}
            >
              {item.label}
            </Link>
          ) : (
            <span style={{ color: '#6c757d', fontWeight: '400' }}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumb; 